var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13L11.008 8C11.008 7.73479 11.1134 7.48043 11.3009 7.2929C11.4884 7.10536 11.7428 7 12.008 7C12.2732 7 12.5276 7.10536 12.7151 7.2929C12.9026 7.48043 13.008 7.73479 13.008 8L13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.994 17C12.5463 17 12.994 16.5523 12.994 16C12.994 15.4477 12.5463 15 11.994 15C11.4417 15 10.994 15.4477 10.994 16C10.994 16.5523 11.4417 17 11.994 17Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22H11.985C9.33283 21.998 6.79008 20.9425 4.91612 19.0658C3.04217 17.189 1.99051 14.6447 1.9925 11.9925C1.99448 9.34034 3.04996 6.79759 4.92673 4.92363C6.8035 3.04967 9.34783 1.99801 12 2H12.015C14.6672 2.00199 17.2099 3.05747 19.0839 4.93424C20.9578 6.81101 22.0095 9.35534 22.0075 12.0075C22.0055 14.6597 20.95 17.2024 19.0733 19.0764C17.1965 20.9503 14.6522 22.002 12 22ZM12 4C9.87826 3.99841 7.8428 4.83974 6.34138 6.33891C4.83997 7.83807 3.99559 9.87227 3.994 11.994C3.9924 14.1157 4.83373 16.1512 6.3329 17.6526C7.83206 19.154 9.86626 19.9984 11.988 20H12C14.1189 19.9976 16.1506 19.1557 17.65 17.6585C19.1494 16.1613 19.9944 14.1309 20 12.012C20.0016 10.9614 19.7962 9.92083 19.3956 8.94962C18.995 7.97841 18.4071 7.09561 17.6653 6.35163C16.9236 5.60765 16.0426 5.01705 15.0726 4.61356C14.1025 4.21006 13.0626 4.00158 12.012 4H12Z",
    fill: "#D52B1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4232b999fb4cb3770f899ff11fe61e20.svg";
export { ForwardRef as ReactComponent };